export interface IAudit {
	action: string;
	occurred: number;
	projectID: string;
	userID?: string;
	device?: string;
	method: string;
	geo?: string;
	remoteAddress?: string;
	host?: string;
	externalIDs?: string[];
	tenants?: string[];
	data: Record<string, unknown>;
}

export interface IAudits extends Array<IAudit> {}

export interface IAuditFilter {
	from?: number;
	to?: number;
	userIds?: string[];
	actions?: string[];
	devices?: string[];
	methods?: string[];
	geos?: string[];
	remoteAddresses?: string[];
	hosts?: string[];
	externalIds?: string[];
	tenants?: string[];
	noTenants: boolean;
}

export type AuditActionType = 'info' | 'warn' | 'error' | 'unknown';

export interface IAuditMetadata {
	message: string;
	type: AuditActionType;
}

export enum AuditsTimePeriod {
	Minutes15 = 'minuets15',
	Hour = 'hour',
	Hour6 = 'hour6',
	Day = 'day',
	Day3 = 'day3',
	Week = 'week',
	Week2 = 'week2',
	Month = 'month'
}
